// Module
var code = `<input show-errors type="text" id="block-input-{{block.id}}" class="form-control" ng-model="answer.value" ng-model-options="{ debounce: 1000 }" ng-required="block.required" ng-disabled="editBlock"/> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/blocks/textQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;